import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { Trad } from "src/components/";

const useStyles = makeStyles({
    addIcon: {
        marginLeft: "5px"
    }
});

interface IAddClientButtonProps {
    OnAddClient: (val: string) => void;
}

export const _AddClientButton: React.FC<IAddClientButtonProps> = ({ OnAddClient, children }) => {
    const classes = useStyles();

    const openPopup = () => {
        const clientDetailsPopup: Window | null = window.open("/anagrafica/0?Popup=true", "ClientPopup", "width=1920,height=1080");

        if (clientDetailsPopup != null) {
            clientDetailsPopup.onbeforeunload = () => {
                const popupID_Anag = clientDetailsPopup?.document.getElementById("PopupID_Anag") as HTMLInputElement | null;

                if (popupID_Anag != null && popupID_Anag.value) {
                    OnAddClient(popupID_Anag.value);
                }
            };
        }
    };

    return (
        <Box display="flex">
            {children}
            <Box display="flex" alignSelf="center">
                <Tooltip title={Trad.Trad("Nuovo")}>
                    <IconButton aria-label="new" size="small" color="secondary" onClick={openPopup} className={classes.addIcon}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/AddClientButton.tsx